// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CrossChain_wrapper__1d9hA","panel":"CrossChain_panel__1DPjV"};